import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginAttemptInfo } from 'src/app/shared/models/auth';

@Component({
  selector: 'app-login-info-dialog',
  templateUrl: './login-info-dialog.component.html',
  styleUrls: ['./login-info-dialog.component.less']
})
export class LoginInfoDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<LoginInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: LoginAttemptInfo
  ) {}

  close(): void {
    this.dialogRef.close();
  }
}